module.exports = __webpack_public_path__ + "img/monitor.a590bf9f.svg";